// Initializes a static-feel Google Map on every element marked with `data-branch-map`.
// No pan, no zoom, no controls — the map is a visual locator only. The marker is the
// one interactive element: clicking/tapping the pin opens Google Maps in a new tab,
// centered on the branch. The Google Maps JS API loader on the cshtml fires
// `window.initBranchMaps` once the library is ready.
class BranchMap {
    init() {
        window.initBranchMaps = () => this.renderAll();

        // If the API loaded before this module (e.g. cached script), render now.
        if (window.google && window.google.maps) {
            this.renderAll();
        }
    }

    renderAll() {
        const nodes = document.querySelectorAll('[data-branch-map]');
        nodes.forEach(node => this.renderOne(node));
    }

    renderOne(node) {
        if (node.dataset.branchMapInit === '1') return;

        const lat = parseFloat(node.dataset.lat);
        const lng = parseFloat(node.dataset.lng);
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const position = { lat, lng };
        const map = new window.google.maps.Map(node, {
            center: position,
            zoom: 15,
            disableDefaultUI: true,
            gestureHandling: 'none',
            keyboardShortcuts: false,
            clickableIcons: false,
        });

        const marker = new window.google.maps.Marker({
            position,
            map,
            title: node.dataset.title || '',
        });

        // Pin is the one interactive element — click/tap opens Google Maps
        marker.addListener('click', () => {
            const url = node.dataset.mapsUrl
                || `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            window.open(url, '_blank', 'noopener,noreferrer');
        });

        node.dataset.branchMapInit = '1';
    }
}

export default BranchMap;

(() => {
    const branchMap = new BranchMap();
    branchMap.init();
})();
